"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M8.4141 3.58575C9.1951 4.36675 9.1951 5.63275 8.4141 6.41375C7.6331 7.19475 6.3671 7.19475 5.5861 6.41375C4.8051 5.63275 4.8051 4.36675 5.5861 3.58575C6.3671 2.80475 7.6331 2.80475 8.4141 3.58575ZM16 10.9998C17.104 10.9998 18 11.8959 18 12.9999V14.6878C18 14.9129 17.93 15.1328 17.787 15.3059C17.322 15.8659 16.011 16.9999 13 16.9999C9.986 16.9999 8.675 15.8638 8.212 15.3048C8.069 15.1318 8 14.9118 8 14.6878V12.9999C8 11.8959 8.896 10.9998 10 10.9998H16ZM6 12.9999V13.9518C3.69 13.7359 2.62 12.7978 2.212 12.3048C2.069 12.1318 2 11.9118 2 11.6878V9.99985C2 8.89585 2.896 7.99985 4 7.99985H9C9 8.37985 9.07 8.73985 9.17 9.08885C7.362 9.47285 6 11.0788 6 12.9999ZM13 5.99985C14.104 5.99985 15 6.89585 15 7.99985C15 9.10385 14.104 9.99985 13 9.99985C11.896 9.99985 11 9.10385 11 7.99985C11 6.89585 11.896 5.99985 13 5.99985Z",
    fill: "#727B7F"
  }));
};